import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Buttons, FlexContainer, ModalContext, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { history } from 'Store';
import { userStageSelector } from 'Store/modules/validations/selectors';
import { useTranslation } from 'Hooks/useTranslation';
import { useFlags } from 'Hooks/useFlags';
import { resultTypeTexts } from 'Containers/PreviousYears/utils';
import { ShareModal } from 'Components/Modal/components';
import { routes, routesByStage } from 'Constants/routes';
import { TAXDOWN_ASSETS_DOMAIN } from 'Constants/domains';
import { FlagsKey } from 'Types/common';
import * as Styled from '../../styles';
import { ResultBoxProps } from './types';

const ResultBox = ({ data }: ResultBoxProps): JSX.Element => {
  const { enabled: flowEnabled } = useFlags(FlagsKey.FLOW_ENABLED);
  const { enabled: mgmEnabled } = useFlags(FlagsKey.MGM_FLOW_ENABLED);
  const { showModal } = useContext(ModalContext);
  const { t } = useTranslation(locizeNS.PY);
  const userStage = useSelector(userStageSelector);

  const openShareModal = (): void => {
    showModal({
      comp: <ShareModal isFiling={false} />,
    });
  };

  const handleClick = (): void => {
    if (flowEnabled || (mgmEnabled && userStage && !routesByStage[userStage])) {
      history.push(routes.PLANS);
    } else if (userStage && !routesByStage[userStage] && !mgmEnabled) {
      openShareModal();
    } else if (userStage && routesByStage[userStage]) {
      history.push(routesByStage[userStage]);
    }
  };

  const refundStatus = data?.refundStatusType?.toUpperCase();
  const resultTypeCopys = resultTypeTexts[refundStatus];
  return (
    <Styled.Box direction="column" align="center" gap="dimension_16">
      <FlexContainer direction="column" align="center" justify="center" gap="dimension_08">
        <img src={`${TAXDOWN_ASSETS_DOMAIN}/illustrations/default/heart_s.png`} alt="heart" />
        <Text align="center" type="fds_text_bold_XL" color="dark_500">
          {t(resultTypeCopys?.title)}
        </Text>
      </FlexContainer>
      <FlexContainer direction="column" align="center" justify="center" gap="dimension_16">
        <Text type="paragraphs" color="dark" size="S_M_M" align="center">
          {t('PreviousYears.button.description', {
            context: userStage && !routesByStage[userStage] && !mgmEnabled && 'mgm',
          })}
        </Text>
        <Text type="paragraphs" color="dark" size="S_M_M" align="center">
          {t('PreviousYears.result.info', {
            context: userStage && routesByStage[userStage] && !mgmEnabled && 'flow',
          })}
        </Text>
      </FlexContainer>
      <Buttons.Classic
        label={t('PreviousYears.button.label', {
          context: userStage && !routesByStage[userStage] ? 'hasSubmitted' : !mgmEnabled && 'mgm',
        })}
        size="m"
        onClick={handleClick}
        mode="primary"
      />
    </Styled.Box>
  );
};

export default ResultBox;
